// import { GoogleLogin } from '@react-oauth/google';
// import { loginWithGoogle } from '../api/auth';

const LoginPage = () => {
  // const handleLoginSuccess = async (credentialResponse: any) => {
  //   const googleToken = credentialResponse.credential;
  //   try {
  //     const data = await loginWithGoogle(googleToken);
  //     localStorage.setItem('token', data.access_token);
  //     alert('Login successful!');
  //     // Optionally redirect or fetch profile
  //   } catch (err) {
  //     console.error('Login failed');
  //   }
  // };

  return (
    <div>
      <h1>Login</h1>
      {/* <GoogleLogin onSuccess={handleLoginSuccess} onError={() => alert('Google Sign-In Failed')} /> */}
    </div>
  );
};

export default LoginPage;